module.exports = __webpack_public_path__ + "img/Pbond.914926fa.svg";